import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import * as _ from 'lodash';
import * as moment from "moment";


@Injectable()
export class JoinServiceService {

  constructor(private _http: HttpClient) { }

  addMember(v_id: string, fields: any): Observable<any> {
    // console.log(_);
    console.log(fields);

    let data: any[] = _.cloneDeep(fields);

    data['general_fields'] = data['general_fields'].map(function (f) {
      if (f['value'] && f['field_name'] == 'Gender') {
        f.value = f.value == 'Male' ? 1 : f.value == 'Female' ? 2 : 0;
      }
      if (f['value'] && f['field_type'] == 'datetime') {
        f.value = moment(`${f.value.year}-${f.value.month}-${f.value.day}`, 'YYYY-MM-DD').toString();
      }
      if (f['value'] && typeof f.value == "object") {
        f.value = JSON.stringify(f.value);
      }
      if (f.formControl) {
        delete f.formControl;
      }
      if (f.invalidTooltip) {
        delete f.invalidTooltip;
      }
      return f
    });

    data['custom_fields'] = data['custom_fields'].map(function (f) {
      //convert string to number
      if (f.field_type == "Number") {
        f.value = Number(f.value);
      }
      if (f['value'] && f['field_type'] == 'Date') {
        f.value = moment(`${f.value.year}-${f.value.month}-${f.value.day}`, 'YYYY-MM-DD').format('YYYY-MM-DD');
      }
      if (f['value'] && typeof f.value == "object") {
        f.value = JSON.stringify(f.value);
      }
      if (f.formControl) {
        delete f.formControl;
      }
      if (f.invalidTooltip) {
        delete f.invalidTooltip;
      }
      //convert string to number
      return f
    });

    data['special_fields'] = data['special_fields'].map(function (f) {
      //convert string to number
      if (f.field_type == "Number") {
        f.value = Number(f.value);
      }
      if (f['value'] && typeof f.value == "object") {
        f.value = JSON.stringify(f.value);
      }
      if (f.formControl) {
        delete f.formControl;
      }
      if (f.invalidTooltip) {
        delete f.invalidTooltip;
      }
      return f
    });


    // let url = 'https://dev.vecport.net/api/vectron-crm/public/api/voucher/placeOrder?hash='+v_id;
    let url = environment.api + 'widget/subscriber?hash=' + v_id;
    // let params = new HttpParams()
    // .set('data', JSON.stringify(data));

    console.log(data);


    return this._http.post(url, { data: JSON.stringify(data) });
  }

}
